import { CurrencySelectorCurrencyFragment } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

interface Props {
  options: CurrencySelectorCurrencyFragment[]
  selected: string
  setSelected: (value: string) => void
}

const CurrencyFilter = ({ options, selected, setSelected }: Props) => {
  const currencies = options.map((option) => ({
    label: option.isoCode,
    value: option.isoCode,
  }))

  return (
    <Filter.EntitySelector
      label={i18n.t('finance.currency')}
      value={[{ isoCode: selected }]}
      nameAttribute={'isoCode'}
      onValueChange={() => {}}
      component={() => (
        <Selector.Container
          value={[selected]}
          blankLabel={i18n.t('common.empty')}
          onChange={(selection) => {
            if (typeof selection === 'string') {
              setSelected(selection)
            }
          }}
          searchPlaceholder={i18n.t('common.search')}
        >
          {currencies.map((currency) => (
            <Selector.Option
              key={currency.value}
              value={currency.value}
              label={currency.label}
              searchValue={currency.label}
              isHidden={currency.value === selected}
            >
              {currency.label}
            </Selector.Option>
          ))}
        </Selector.Container>
      )}
    />
  )
}

export default CurrencyFilter
